// @flow

import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import slideMedia from './assets/slide'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.complotIPA',
  title: 'hardCoded.title.complotIPA',
  slug: titleToSlug('hardCoded.title.complotIPA'),
  catalog: {
    title: 'hardCoded.catalog.title.complotIPA',
    catalogMedia,
    price: numberToCurrency('1.90'),
    color: '#8dcfd7'
  },
  slide: {
    order: 1,
    media: slideMedia,
    color: 'white',
    background: '#86D4D9',
    detailLink: 'home.viewDetailLinks.complot'
  }
}
